var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m177.10696,256.2l189.2,189c13.9,13.9 14,36.4 0.1,50.3l-0.1,0.1c-14,13.9 -36.6,13.9 -50.6,0l-214.3,-214.1c-13.5,-13.5 -13.9,-35.2 -1,-49.3l215.2,-215.6c13.9,-14 36.6,-14 50.5,-0.1c14,13.9 14,36.6 0.1,50.5l-189.1,189.2z",
    id: "Icon_ionic-ios-arrow-forward"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.1414420bf854db421faf4ca08796a20a.svg";
export { ForwardRef as ReactComponent };